import { render, staticRenderFns } from "./detailBox.vue?vue&type=template&id=852d60e6&scoped=true&"
import script from "./detailBox.vue?vue&type=script&lang=js&"
export * from "./detailBox.vue?vue&type=script&lang=js&"
import style0 from "./detailBox.vue?vue&type=style&index=0&id=852d60e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852d60e6",
  null
  
)

export default component.exports